import { Box } from "@mui/material";
import UserProfile from "../../components/User/UserProfile"; // Adjust the path if needed
import Header from "../../components/Header";

const Profile = () => {
  return (
    <Box
      sx={{
        width: "100%",
        overflowX: "hidden",
        boxSizing: "border-box",
        p: { xs: 2, sm: 3, md: 4 },
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Header
          title="USER PROFILE"
          subtitle="View your profile information here"
        />
      </Box>
      <UserProfile />
    </Box>
  );
};

export default Profile;
